import classNames from 'classnames';
import { useAppContext } from 'providers/AppProvider';
import { Button, Navbar } from 'react-bootstrap';
import logo from 'assets/img/brand/pro1.png';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarToggleButton from './NavbarToggleButton';
import { Link } from 'react-router-dom';
import { IoReorderThreeOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const NavbarBrand = () => {
  const {
    config: { navbarTopShape, navbarPosition, isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();
  const { breakpoints } = useBreakpoints();
  const role = useSelector((state: RootState) => state.auth.user?.role);
  return (
    <>
      <div className="navbar-logo ">
        {breakpoints.down('lg') && <NavbarToggleButton />}
        <Navbar.Brand
          as={Link}
          to="/dashboard/properties"
          className={classNames({
            'me-1 me-sm-3':
              navbarTopShape === 'slim' || navbarPosition === 'horizontal'
          })}
        >
          {navbarTopShape === 'slim' ? (
            <>
               {/* Propertiesbyphone */}
              <span className="text-body-highlight d-none d-sm-inline">
                slim
              </span>
            </>
          ) : (
            <div className="d-flex align-items-center">
              {breakpoints.up('xs') &&
              breakpoints.down('sm') &&
              breakpoints.down('lg') &&
              breakpoints.down('md') ? null : (
                // <img src={logo} alt="phoenix" width={60} />
                <></>
              )}

              {!isNavbarVerticalCollapsed && (
                <h2 className="logo-text ms-2 d-none d-sm-block">
                  {/* Property by phone */}
                </h2>
              )}
            </div>
          )}
        </Navbar.Brand>
        {/* {role && role === 'admin' ? (
          <div
            className={classNames(
              'navbar-vertical-footer d-flex align-items-center',
              { 'ms-3': !isNavbarVerticalCollapsed }
            )}
          >
            <div
              className="navbar-vertical-toggle border-0 fw-semibold white-space-nowrap d-flex align-items-center"
              onClick={() => {
                setConfig({
                  isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
                });
              }}
            >
              {breakpoints.up('xs') && breakpoints.down('lg') ? null : (
                <IoReorderThreeOutline size={16} className="mb-1" />
              )}

            </div>
          </div>
        ) : (
          <></>
        )} */}
      </div>
    </>
  );
};

export default NavbarBrand;
